
const handler      = require ('./quickform-form-check-required-handler')
const multitable   = require ('../multitable/multitable')
const snack        = require ('../snack/snack')


//add or remove input errors on form
export function formCheck(form){ //console.log('formCheck', tabNotify)
    
  var existError = false

  form.forEach((elem)=>{ 
        if(elemDetection(elem)){ 
            existError = true 
        }
  })/*foreach*/ 


  return existError
}


function elemDetection(elem){ //console.log('############>', elem.type)

    var existError = false 

    switch (elem.type){
           case 'textfield':               
                if( handler.textfieldCheck(elem) )   { existError = true } break;

           case 'autocomplete': 
                if( handler.autocompleteCheck(elem)) { existError = true } break;
            
           case 'textfieldValidator': 
                if( handler.textValidatorCheck(elem)){ existError = true } break;

           case 'checkbox':  
                if( handler.checkboxCheck(elem))     { existError = true } break;

           case 'multiselect': 
                 if( handler.multiselectCheck(elem)) { existError = true } break;

           case 'radio': //radio//slider
                 if( handler.radioCheck(elem))       { existError = true } break;

    }/*swtich*/

    return existError

}/**/














